module.exports = __webpack_public_path__ + "img/img4.232b4684.jpg";